<template>
    <v-snackbar :value="isProcessing" :timeout="-1" color="info" bottom app multi-line>
        <div class="d-flex align-center">
            <v-progress-circular indeterminate size="20" width="2" class="mr-3" />
            Compression de la photo en cours...
        </div>
    </v-snackbar>
</template>

<script>
export default {
    name: "PhotoCompressionLoader",
    computed: {
        isProcessing() {
            return this.$store.getters["photoCompression/isProcessing"];
        },
    },
};
</script>
